var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",staticClass:"code-matrix",style:({ opacity: _vm.codeScreenOpacity }),attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }